import React from 'react'

const Logout = (props) => (
  <li style={{ cursor: 'pointer' }} onClick={() => props.onLogoutClick()}>
    <i className='fa fa-sign-out' /> Log Out
  </li>
)

export default Logout
